import { render } from "./CodePress.vue?vue&type=template&id=2371f75d"
import script from "./CodePress.vue?vue&type=script&lang=js"
export * from "./CodePress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__